import React, { useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import PastRequestReenroll from "./PastRequestReenroll";
import CalendarDatePicker from "../../componenents/CalendarDatePicker";
import { decryptData } from "../../utils/Utils";
import moment from "moment";

function ContentMemberRegisterLaterDetails() {
  const storedDates = localStorage.getItem("selectedDates")
    ? JSON.parse(decryptData(localStorage.getItem("selectedDates")))
    : "";
  const [startDate, setStartDate] = useState(
    storedDates && storedDates.length === 4 ? moment(storedDates[0]) : moment()
  );
  const [endDate, setEndDate] = useState(
    storedDates && storedDates.length === 4 ? moment(storedDates[1]) : moment()
  );

  const handleDateChange = ({ start, end }) => {
    setStartDate(start);
    setEndDate(end);
  };

  /*const [currentReEnrollRequests, setCurrentReenrollRequests] = useState([]);
    const [pastReEnrollRequests, setPastReenrollRequests] = useState([]);

    useEffect(() => {
        fetchAgentMemberEnrollList();
    }, []);


    // fetching re-enroll requests made by agents 
    const fetchAgentMemberEnrollList = async () => {
        try {
            let response = await fetch_all_members_reenroll();
            if (response.data.code === 200) {
                let currentRequests = response.data?.data?.filter((request) => request.requestStatus === "Pending");
                let pastRequests = response.data?.data?.filter((request) => request.requestStatus !== "Pending");

                setCurrentReenrollRequests(currentRequests);
                setPastReenrollRequests(pastRequests);
            }
        } catch (error) {
            console.log(error);
        } finally {
        }
    };*/

  return (
    <>
      <section className="ContentMemberDeEnrollment">
        <div className="row align-items-center pb-3 sticky-top-bar">
          <div className="col-md text-start">
            <h1 className="main-title">Member Re-enroll Details</h1>
          </div>

          <div className="col-md-3">
            <CalendarDatePicker
              startDate={startDate}
              endDate={endDate}
              onDateChange={handleDateChange}
            />
          </div>
        </div>
        <div className="reports-programs mb-3">
          <div className="row align-items-center">
            <div className="col-md-auto">
              <img
                src="hhttps://storecdn.goqii.com/media/goqiiweb/assets/images/site-logo.png"
                alt="Invited Members icon"
                style={{ height: "140px" }}
                className="img-fluid mb-0"
              />
            </div>
            <div className="col-md">
              <p className="mb-3">
                "Re-enrollment requests allow members to rejoin the program.
                This includes members previously de-enrolled by CareNavigators,
                as well as those marked by agents as 'Incorrect' or 'Not
                Interested.'
              </p>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row align-items-center pb-3">
            <div className="comntent-MemberDeEnrollment mb-3">
              <div className="row">
                <div className="col-md-12">
                  <Tabs>
                    <TabList>
                      <Tab>Re-Enrollment History</Tab>
                    </TabList>

                    <TabPanel>
                      <div className="table-responsive ContentMemberRegisterLaterTable">
                        <PastRequestReenroll
                          startDate={startDate}
                          endDate={endDate}
                        />
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default ContentMemberRegisterLaterDetails;
